import styled from 'styled-components';
import { COLORS, DEVICE_SIZE, BORDER_RADIUS, FONT_FAMILY, FONT_WEIGHT, MARGIN, DEVICE_TYPE, SIZE } from 'constants/variables';

export const SearchContainer = styled.div`
   width: 100%;
   padding: ${SIZE.max180} ${SIZE.max220};
   display: flex;
   flex-direction: column;
   @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${SIZE.max220} ${MARGIN.fix32};
   }
`;

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap:24px;
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-bottom: ${MARGIN.fix24};
`;

export const ImgStyled = styled.img``;

export const SearchForm = styled.form`
  display: flex;
  width: 100%;
`;

export const SearchInput = styled.input`
  font-family: ${FONT_FAMILY.poppins};
  font-size: 18px;
  font-weight: ${FONT_WEIGHT.regular};
  width: 100%;
  background-color: ${COLORS.Cultured};
  border: none;
  border-radius: ${BORDER_RADIUS.radius32};
  padding: 11px 24px;
  outline: none;
  color: ${COLORS.RaisinBlack};
  
  &::placeholder {
    color: ${COLORS.MetalicSilver};
  }
`;

export const SearchButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.Crimson};
  color: white;
  border-top-right-radius: ${BORDER_RADIUS.radius32};
  border-bottom-right-radius: ${BORDER_RADIUS.radius32};
  margin-left: -24px;
  padding-right: 24px;
  font-family: ${FONT_FAMILY.poppins};
  font-weight: ${FONT_WEIGHT.medium};
  font-size: 16px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${COLORS.VividAuburn};
  }
  
  svg {
    margin-right: 8px;
  }
`;

export const ResultsGrid = styled.div`
  display flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 40px 0;
  color: ${COLORS.MetalicSilver};
`;
